import React from "react";
import { useTranslation } from "@lib/i18n";
import { useRouter } from "next/router";
import Link from "next/link";
import { bool } from "prop-types";

import { Button } from "@components/shared/Button";
import RequestButton from "@components/shared/RequestButton";
import Typography from "../shared/Typography";

import gtm from "@gtm/core";
import { emptyBasketUpdateUrlEvent } from "@gtm/events/myaccount";
import { getBrandIdLoginRedirect } from "@lib/getBrandIdLoginRedirect";
import { useIsUserTrustedSelector } from "@redux/reducers/auth";
import { useIsB2BSelected } from "@hooks/useIsB2BSelected";
import { useEffect } from "react";
import { useConfigurationPathname } from "@hooks/useConfigurationPathname";
import { ROUTES } from "@shared/routing/routes";
import { redirectToExternalURL } from "@shared/v2/lib/redirectToExternalURL";
import { useGetBrandIdRedirect } from "@hooks/useGetBrandIdRedirect";

import {
  useBrandIdSettingsSelector,
  useReferrerSelector,
} from "@redux/reducers/appConfig";

const EmptyBasket = ({ isSSRRendered }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const isUserTrusted = useIsUserTrustedSelector();
  const router = useRouter();
  const affiliation = useReferrerSelector();
  const isB2BSelected = useIsB2BSelected();
  const brandIDConfig = useBrandIdSettingsSelector();

  const configurationPathname = useConfigurationPathname();
  const getBrandIdRedirect = useGetBrandIdRedirect();

  const localizedRedirectLogin = getBrandIdRedirect(ROUTES.BASKET);

  useEffect(() => {
    gtm.fire(
      emptyBasketUpdateUrlEvent({
        pageTitle: router.asPath,
        affiliation,
        isB2BSelected,
        isSSRRendered,
      })
    );
  }, []);

  return (
    <div className="flex flex-col justify-center items-start gap-4 px-8 py-12 lg:items-center">
      <Typography className="uppercase text-3xl font-semibold">
        {t("basket.emptyTitle")}
      </Typography>
      <Typography className="text-lg pb-4">
        {t("basket.emptyDescription")}
      </Typography>
      {!isUserTrusted && (
        <RequestButton
          data-id="basket-redirect-registration-button"
          triggerRequestCallback={() =>
            redirectToExternalURL(
              getBrandIdLoginRedirect(
                localizedRedirectLogin,
                brandIDConfig,
                language
              )
            )
          }
        >
          {t("auth.signIn")}
        </RequestButton>
      )}
      <Link href={ROUTES.CONFIG} as={configurationPathname}>
        <a data-id="basket-continue-button-link">
          <Button variant="secondary">{t("basket.continue")}</Button>
        </a>
      </Link>
    </div>
  );
};

EmptyBasket.propTypes = {
  isSSRRendered: bool,
};

export default EmptyBasket;
